import isOptionValid from './option';
export default function isOptionsListValid(optionsList) {
    return Array.isArray(optionsList) && optionsList.every((option) => isOptionValid(option));
}
